
/** @typedef {import("./Component").default} Component */
import Vector from "./Vector";
import ReactDOM from "react-dom";

export default class DynamicMap {



    /** @type {HTMLDivElement} */
    #componentsContainer = null;

    constructor(options = {}) {
        this.transform = {
            offset: options.offset || new Vector(0, 0),
            zoomFactor: options.zoomFactor || 1
        };

        /** Size (in pixels) of a unit in the coordinate plane */
        this.unitSize = options.unitSize || 10;

        /** @type {Component[]} */
        this.components = [];

        /** @type {HTMLCanvasElement} */
        this.canvas = null;

        /** @type {SVGElement} */
        this.triggersContainer = null;



        this.highlightComponent = null;
    }

    set componentsContainer(componentsContainer) {
        this.#componentsContainer = componentsContainer;
        
        let dragOrigin = null;
        let offsetOrigin = null;
        this.#componentsContainer.addEventListener("mousemove", event => {
            if(dragOrigin) {
                const point = new Vector(event.clientX, event.clientY);
                const dragOffset = point.subtract(dragOrigin).scale(1/this.relativeUnitSize);
                dragOffset.x *= -1;
                this.transform.offset = offsetOrigin.add(dragOffset);

                this.render();
            }
        });

        this.#componentsContainer.addEventListener("mousedown", event => {
            dragOrigin = new Vector(event.clientX, event.clientY);
            offsetOrigin = this.transform.offset;
        });

        this.#componentsContainer.addEventListener("mouseup", event => {
            dragOrigin = null;
            offsetOrigin = this.transform.offset;
        });

        this.#componentsContainer.addEventListener("mouseleave", event => {
            dragOrigin = null;
            offsetOrigin = this.transform.offset;
        });
    }

    get componentsContainer() { return this.#componentsContainer; }
    get relativeUnitSize() {
        return this.unitSize * this.transform.zoomFactor;
    }


    render({ paintOnly = false } = {}) {
        setTimeout(() => this.beginRender(paintOnly), 1);
    }

    beginRender({ paintOnly = false } = {}) {
        const { components, canvas, triggersContainer, componentsContainer, relativeUnitSize, transform: { offset, zoomFactor }, unitSize } = this;
        if(!canvas) throw new Error("Canvas not yet setup.");
        if(!componentsContainer) throw new Error("Container not yet setup.");

        const context = canvas.getContext("2d");
        const { width, height } = canvas;

        const centerX = width / 2;
        const centerY = height / 2;

        context.clearRect(0, 0, width, height);

        componentsContainer.addEventListener("contextmenu", () => console.log(this.transform));
        

        /** @param {import("./Polygon").default} polygon */


        function getCanvasPosition(point) {
            const x = (point.x - offset.x)*relativeUnitSize + centerX;
            const y = centerY - (point.y - offset.y)*relativeUnitSize;

            return new Vector(x, y);
        }

        function getFocalPoint(event) {
            const { left, top } = canvas.getBoundingClientRect();
            return new Vector(event.clientX - left, event.clientY - top);
        }

        // componentsContainer.innerHTML = "";
        if(!paintOnly) triggersContainer.innerHTML = "";


        const arrangedComponents = components.filter(c => c !== this.highlightComponent);
        if(this.highlightComponent && arrangedComponents.length !== components.length) arrangedComponents.push(this.highlightComponent)

        for(const component of arrangedComponents) {
            const { element, trigger, polygons } = component;

            if(!paintOnly && element) {
                const { x, y } = getCanvasPosition(component.center);
                
                element.style.position = "absolute";
                element.style.left = x + "px";
                element.style.top = y + "px";
            }

            if(!paintOnly && trigger) {
                for(const polygon of polygons) {
                    if(!polygon.triggerElement) {
                        const triggerElement = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
                        triggerElement.style.fill = "transparent";  
                        triggerElement.style.strokeWidth = 0; 
                        triggerElement.style.cursor = "pointer"; 
                        
    
                        if(trigger.onClick) triggerElement.addEventListener("click", () => trigger.onClick(component));
                        if(trigger.onHover) triggerElement.addEventListener("mouseover", e => {
                            if(!trigger.hovering) {
                                trigger.onHover(component, getFocalPoint(e));
                                trigger.hovering = true;
                            }
                        });

                        if(trigger.onHoverMove) triggerElement.addEventListener("mousemove", e => {
                            trigger.onHoverMove(component, getFocalPoint(e));
                        });
    
                        if(trigger.onHoverOut) ["mouseout", "mouseleave"].forEach(
                            event => triggerElement.addEventListener(event, e => {
                                if(trigger.hovering) {
                                    trigger.onHoverOut(component, getFocalPoint(e));
                                    trigger.hovering = false;
                                }
                            })
                        );

                        polygon.triggerElement = triggerElement;
                    }

                    const { triggerElement } = polygon;

                    const points = polygon.points.map(point => {
                        const { x, y } = getCanvasPosition(point);
                        return x + "," + y;
                    }).join(" ");

                    triggerElement.setAttribute("points", points);


                    triggersContainer.appendChild(triggerElement);
                }
                
                
                
                    
                
                
            }


            context.beginPath();

            for(const polygon of polygons) {
                const { points, style } = polygon;

                context.fillStyle = style.fillColor;
                context.strokeStyle = style.stroke.color;
                context.lineWidth = style.stroke.width;
                
                let beginning = true;
            
                for(const point of points) {
                    const { x, y } = getCanvasPosition(point);
                    
                    if(beginning) {
                        context.moveTo(x, y);
                        beginning = false;
                    } else context.lineTo(x, y);
                }

                // if(!beginning) {
                //     context.closePath();
                //     context.stroke();
                //     context.fill();
                // }
            }

            context.stroke();
            context.fill();

        }
        
    }
}